import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import {
  AiLiteracyTutorBanner,
  AiLiteracyTutorIntroduction,
  AiLiteracyTutorMomentHighlight,
  AiLiteracyTutorTutor,
  AiLiteracyTutorLearningPackage
} from '../types';

export const fetchAiLiteracyTutorBanner = async (): Promise<AiLiteracyTutorBanner | null> => {
  const response = await fetch(API_ENDPOINTS.aiLiteracyTutorBanner, {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(`AI Literacy Tutor Banner request failed: ${response.status}`);
  }
  const data: AiLiteracyTutorBanner[] = await response.json();
  return Array.isArray(data) && data.length > 0 ? data[0] : null;
};

export const fetchAiLiteracyTutorIntroduction = async (): Promise<AiLiteracyTutorIntroduction | null> => {
  const response = await fetch(API_ENDPOINTS.aiLiteracyTutorIntroduction, {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(`AI Literacy Tutor Introduction request failed: ${response.status}`);
  }
  const data: AiLiteracyTutorIntroduction[] = await response.json();
  return Array.isArray(data) && data.length > 0 ? data[0] : null;
};

export const fetchAiLiteracyTutorMomentHighlight = async (): Promise<AiLiteracyTutorMomentHighlight | null> => {
  const response = await fetch(API_ENDPOINTS.aiLiteracyTutorMomentHighlight, {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(`AI Literacy Tutor Moment Highlight request failed: ${response.status}`);
  }
  const data: AiLiteracyTutorMomentHighlight[] = await response.json();
  return Array.isArray(data) && data.length > 0 ? data[0] : null;
};

export const fetchAiLiteracyTutorTutors = async (): Promise<AiLiteracyTutorTutor[]> => {
  const response = await fetch(API_ENDPOINTS.aiLiteracyTutorTutors, {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(`AI Literacy Tutor Tutors request failed: ${response.status}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

export const fetchAiLiteracyTutorLearningPackages = async (): Promise<AiLiteracyTutorLearningPackage[]> => {
  const response = await fetch(API_ENDPOINTS.aiLiteracyTutorLearningPackages, {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(`AI Literacy Tutor Learning Packages request failed: ${response.status}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : [];
};
